import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

type SettingsSectionTitleProps = {
    title: string;
    description?: string;
    dataAutomation?: string;
};

export const SettingsSectionTitle = ({ title, description, dataAutomation }: SettingsSectionTitleProps) => {
    return (
        <Stack
            gap="4px"
            data-automation={dataAutomation}
            width="100%"
        >
            <Text
                as="p"
                fontVariant="h5"
                color={colorsPalettes.carbon["400"]}
                margin="0"
                textTransform="capitalize"
            >
                {title}
            </Text>
            {description ? (
                <Text
                    as="p"
                    fontVariant="body2"
                    color={colorsPalettes.carbon["250"]}
                    margin="0 0 4px"
                >
                    {description}
                </Text>
            ) : null}
        </Stack>
    );
};
